import styled, { css } from 'styled-components';
import { Footer } from '../../footer';
import { pxToRem } from '../../../design-tokens/style-utilities';
export const ApplicationFooterStyles = ({ theme }) => css `
	margin-top: ${pxToRem(theme.spacing['300'])};
`;
export const ApplicationFooter = styled(Footer) `
	${ApplicationFooterStyles}
`;
